import "core-js/modules/es.array.push.js";
export default {
  namespaced: true,
  state: {
    /**
     * 组件缓存
     */
    keepalive: []
  },
  mutations: {
    /**
     * 新增缓存
     * @param state
     * @param name 一般是route.meta.series的值
     */
    commitAddKeepalive(state, name) {
      if (!state.keepalive.includes(name)) {
        state.keepalive.push(name);
      }
    },
    /**
     * 删除执行缓存
     * @param state
     * @param name 一般是route.meta.series的值
     */
    commitDeleteKeepalive(state, name) {
      const index = state.keepalive.indexOf(name);
      index > -1 && state.keepalive.splice(index, 1);
    }
  },
  getters: {
    getKeepalive(state) {
      return state.keepalive;
    }
  }
};